import PropTypes from 'prop-types';

export const CurrencyPropType = PropTypes.oneOfType([PropTypes.number, PropTypes.string]);
